import { useEffect } from "react"
import { useSearchParams, useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetAccountParticipationTicketList = () => {
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/admin/account/${idx}/participate-ticket/list?page=${page}`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "account_idx") setAlert("사용자 idx를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("사용자 데이터가 존재하지 않습니다.")
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetAccountParticipationTicketList